// Course kind = course.camp_ind: 0 regular class, 1 camp, 2 school program.
// Fee rows use the batch types that share the course's camp_ind (class 1,
// camps 2/3/5/6, "School Program" 7).
//
// batch_type 7 is "School Program". A school course's branch default fee is a
// single branch_course_fee row with this batch type; per-program overrides live
// on school_program_course.custom_fee.
export const CLASS_CAMP_IND = 0;
export const CAMP_CAMP_IND = 1;
export const SCHOOL_CAMP_IND = 2;
export const SCHOOL_PROGRAM_BATCH_TYPE = 7;

const KIND_BY_FREQUENCY_UNIT = { monthly: CLASS_CAMP_IND, weekly: CAMP_CAMP_IND };

// `course` is a branch-course object from GET /api/branch-course/:branchId or
// /branch-course-detail/:id: { camp_ind?, frequency_unit?, fees: [] }.
// Prefer the course-level camp_ind; a branch course with no fee rows
// (fees: []) can only be classified by it. Older servers don't send camp_ind
// but always send at least one fee row, so fall back to that row's batch type.
export const getCourseCampInd = (course, batchTypes = []) => {
  if (course?.camp_ind != null && course.camp_ind !== "") {
    return Number(course.camp_ind);
  }
  const firstType = course?.fees?.[0]?.batch_type;
  if (firstType != null) {
    const bt = batchTypes.find((b) => String(b.id) === String(firstType));
    if (bt) return Number(bt.camp_ind);
    if (Number(firstType) === SCHOOL_PROGRAM_BATCH_TYPE) return SCHOOL_CAMP_IND;
    return Number(firstType) === 1 ? CLASS_CAMP_IND : CAMP_CAMP_IND;
  }
  // No camp_ind and no fees: shouldn't happen (only the new server sends
  // fees: [] and it also sends camp_ind). Best guess from frequency_unit.
  return KIND_BY_FREQUENCY_UNIT[course?.frequency_unit] ?? CLASS_CAMP_IND;
};

export const isSchoolCourse = (course, batchTypes) =>
  getCourseCampInd(course, batchTypes) === SCHOOL_CAMP_IND;

// The fee-table components predate course kinds and branch on a `type` that
// used to be fees[0].batch_type; they only ever compare it with 1 (regular
// class). Derive it from the kind so it works with no fee rows.
export const getLegacyTableType = (campInd) =>
  campInd === CLASS_CAMP_IND
    ? 1
    : campInd === SCHOOL_CAMP_IND
    ? SCHOOL_PROGRAM_BATCH_TYPE
    : 2;

// frequency_unit for a new row: copy the course's existing rows, else the
// kind's convention (classes monthly, camps weekly, school defaults custom).
export const getNewRowFrequencyUnit = (course, campInd) =>
  course?.fees?.[0]?.frequency_unit ??
  (campInd === CLASS_CAMP_IND
    ? "monthly"
    : campInd === CAMP_CAMP_IND
    ? "weekly"
    : "custom");

export const getNewRowVirtualFee = (course) =>
  course?.fees?.[0]?.virtual_course_fee ?? course?.virtual_course_fee ?? 0;
